<template lang="pug">
  article.accordion(:class="{ 'is-active':state, 'is-disabled': disabled}")
    .accordion-header(@click="toogleAccordion()")
      slot(name="header")
    .accordion-body(v-show="state")
      .accordion-content
        slot
</template>

<script>
export default {
  name: 'VAccordion',
  data () {
    return {
      state: false
    }
  },
  props: {
    disabled: {
      default: false
    }
  },
  methods: {
    toogleAccordion () {
      this.state = !this.state
    }
  }
}
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/billing/invoice/components/accordion/index.vue